import type { OutcomeContext } from '@modules/_shared/components/feed/types';

export const getBuyerLeadOutcomeContext = (
  buyerLeadId: string,
): OutcomeContext => ({
  activityId: '',
  parentType: 'BuyerLead',
  parentId: buyerLeadId,
  pipelineType: 'buyer',
});
